import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CollectionTranslation')
export class CollectionTranslation {

  @JsonProperty('language_id', Number)
  languageId: number = 0;

  @JsonProperty('name', String)
  name: string = '';
}
